'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _FormValidationService = require('./../../../common/services/FormValidationService');

var _FormValidationService2 = _interopRequireDefault(_FormValidationService);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CompanyEditController = function () {
  function CompanyEditController(authService, $stateParams, enums, companyService, loadingService, $state) {
    "ngInject";

    (0, _classCallCheck3.default)(this, CompanyEditController);
    this.authService = authService;
    this.enums = enums;
    this.companyService = companyService;
    this.loadingService = loadingService;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.formValidationService = new _FormValidationService2.default();

    var permissionToCheck = void 0;
    if ($stateParams.companyId) {
      permissionToCheck = enums.PERMISSION_TYPE.Edit;
    } else {
      permissionToCheck = enums.PERMISSION_TYPE.Add;
    }
    if (!authService.validateUser(false, 'Company', permissionToCheck, true)) {
      return;
    }

    this.panels = {
      company: true
    };

    this.company = {
      entityId: authService.authData.currentLocation.key,
      address: {},
      contactPhones: [],
      contactEmails: []
    };
    this.selectOptions = {};
    this.selectDefaults = {};

    this.initializeEnums();
    this.configureForm();

    this.loadCompany();
  }

  (0, _createClass3.default)(CompanyEditController, [{
    key: 'initializeEnums',
    value: function initializeEnums() {
      var ctrl = this;
      var enumList = [{ enumName: 'COMPANY_TYPE', propName: 'companyType' }];

      enumList.map(function (item) {
        var enumsArray = ctrl.convertEnumToKeyValueList(ctrl.enums[item.enumName]);
        ctrl.selectOptions[item.propName] = enumsArray;
        ctrl.selectDefaults[item.propName] = ctrl.getDefaultOption(enumsArray, item.propName);
        ctrl.updateModelFromSelect(item.propName);
      });
    }
  }, {
    key: 'convertEnumToKeyValueList',
    value: function convertEnumToKeyValueList(enumObj) {
      var objList = [];

      for (var prop in enumObj) {
        objList.push({
          id: enumObj[prop],
          name: prop
        });
      }

      return objList;
    }
  }, {
    key: 'getDefaultOption',
    value: function getDefaultOption(enumsArray, propName) {
      var propVal = void 0;

      try {
        propVal = eval('this.company.' + propName);
      } catch (e) {}

      if (propVal) {
        return (0, _lodash.find)(enumsArray, function (o) {
          return o.id === propVal;
        });
      } else {
        return enumsArray[0];
      }
    }
  }, {
    key: 'updateModelFromSelect',
    value: function updateModelFromSelect(modelProperty) {
      var selectDefaultProperty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : modelProperty;
      var idProperty = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'id';

      this.company[modelProperty] = this.selectDefaults[selectDefaultProperty][idProperty];
    }
  }, {
    key: 'configureForm',
    value: function configureForm() {
      var ctrl = this;

      ctrl.formValidationService.initialize(ctrl.company);

      ctrl.formValidationService.addField({
        fieldName: 'legalName',
        displayName: 'Legal Name',
        type: 'text',
        required: true,
        stringLength: {
          min: 2,
          max: 50
        }
      });

      ctrl.formValidationService.addField({
        fieldName: 'tradingName',
        displayName: 'Trading Name',
        type: 'text',
        stringLength: {
          min: 2,
          max: 50
        }
      });

      ctrl.formValidationService.addField({
        fieldName: 'website',
        displayName: 'Website',
        type: 'url'
      });
    }
  }, {
    key: 'loadCompany',
    value: function loadCompany() {
      var _this = this;

      var ctrl = this;

      if (ctrl.$stateParams.companyId) {
        ctrl.loadingService.showLoading('editCompany', 'Loading Company ...');

        ctrl.companyService.getCompany(ctrl.authService.authData.currentLocation.key, ctrl.$stateParams.companyId).then(function (response) {
          (0, _assign2.default)(ctrl.company, response.data);
          _this.initializeEnums();
          _this.configureForm();
        }).catch(function (err) {}).finally(function () {
          ctrl.loadingService.hideLoading('editCompany');
        });
      }
    }
  }, {
    key: 'redirectToParent',
    value: function redirectToParent(newCompanyId) {
      /*
      * We need to check if there was a contact object passed in stateParams
      * This will mean that we wanted to create a new company while creating a new contact
      * So if the company was created or someone cancelled it
      * We will send the user back add or edit contact passing in the same contact
      * That was passed originally from that screen
      */
      if (this.$stateParams.contact) {
        var params = {
          contact: this.$stateParams.contact
        };

        if (newCompanyId) {
          params.contact.companyId = newCompanyId;
          params.companyName = this.company.legalName;
        }

        /*
        * If the Contact has a ContactId this means that user was editing a contact
        * and decided a attach it to a newly created company
        * otherwise user was in add contact mode and adding new company
        */
        if (params.contact.contactId) {
          params.contactId = params.contact.contactId;
          this.$state.go('contactEdit', params);
        } else {
          this.$state.go('contactAdd', params);
        }
      } else {
        this.$state.go('companyList');
      }
    }
  }, {
    key: 'editCompany',
    value: function editCompany() {
      var _this2 = this;

      var ctrl = this;

      if (!ctrl.formValidationService.validateForm()) {
        return;
      }

      this.state = 'Saving';

      ctrl.loadingService.showLoading('editCompany', 'Saving Changes ...');

      ctrl.companyService.editCompany(ctrl.company).then(function (response) {
        _this2.state = 'Saved';
        ctrl.redirectToParent(response.data);
      }).catch(function (err) {
        if (err.status === 400) {
          //Bad Request
          ctrl.state = 'ModelError';

          err.data.map(function (item) {
            ctrl.formValidationService.addModelError(item.key.substring(item.key.indexOf('.') + 1).toCamelCase(), item.value);
          });
        } else if (err.status === 500) {
          ctrl.state = 'SystemError';
          ctrl.formValidationService.addSystemError(null, "A system error occurred while processing your request. Please try again later or contact system administrator if problem persists.");
        }
      }).finally(function () {
        ctrl.loadingService.hideLoading('editCompany');
      });
    }
  }]);
  return CompanyEditController;
}();

exports.default = CompanyEditController;


// WEBPACK FOOTER //
// ./client/app/components/company/companyEdit/companyEdit.controller.js